import { createFileRoute } from "@tanstack/react-router";
import OAuthConsent from "@/pages/OAuthConsent";

// Deliberately excluded from sitemap.xml: OAuth consent is a private app screen.
export const Route = createFileRoute("/.lovable/oauth/consent")({
  head: () => ({
    meta: [
      { title: "Authorise Application | Garden-Review" },
      { name: "robots", content: "noindex, nofollow" },
      {
        name: "description",
        content: "Review and authorise an application requesting access to your Garden-Review account.",
      },
    ],
  }),
  component: OAuthConsent,
});
